<i class="fs-16px" [uiTooltipTitle]="content" [uiRotate]="0" ui-icon ui-tooltip uiTheme="outline" uiType="help" uiTooltipPlacement="right"></i>
